import { Injectable,EventEmitter } from '@angular/core';
import { HttpHeaders } from "@angular/common/http";
import { HttpClient } from "@angular/common/http";
import {apiurl} from "../../general/global"

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  loginevent = new EventEmitter();

  constructor(
    private http:HttpClient
  ) { }

  doLogin(body){
		const headers = new HttpHeaders();
    headers.append('Content-Type','application/json');
		return this.http.post(apiurl+'usermanagement/login/',body,{headers:headers})
  }

  setUserdata(data) {
    console.log(data,"mmmmmmmmm")
		localStorage.setItem("userdata", JSON.stringify(data));
	}
	setLoginStatus(i){
		i = JSON.stringify(i);
		localStorage.setItem("isLogged",i)
  }

  getUserdata(status) {
    var userdatas = JSON.parse(localStorage.getItem("userdata"));
    console.log(userdatas,"alllll")
		return userdatas;
  }
  getLoginStatus(){
		var loginstate = JSON.parse(localStorage.getItem("isLogged"));
		this.loginevent.emit(loginstate);
		return loginstate
  }
}
